window.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-accessibility]').forEach( trigger => {

        trigger.addEventListener('click', () => {
            
            const data = {
                action: "toggle_accessibility",
                accessibilityType: trigger.dataset.accessibility
            };

            fetch(TWZ.ajaxurl, {
                method: "POST",
                credentials: 'same-origin',
                body: new URLSearchParams(data)
            })
            .then(response => response.json())
            .then(bodyClass => {
                document.body.classList[document.body.classList.contains(bodyClass) ? 'remove' : 'add'](bodyClass);

                console.log(bodyClass);
            });
        });
    });
});

